import { render } from "./InvitationGate.vue?vue&type=template&id=e04b5576&scoped=true"
import script from "./InvitationGate.vue?vue&type=script&lang=js"
export * from "./InvitationGate.vue?vue&type=script&lang=js"

import "./InvitationGate.vue?vue&type=style&index=0&id=e04b5576&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e04b5576"]])

export default __exports__